<section
  class="eventq-notice"
  [class.eventq-notice--orange]="tone() === 'orange'"
  [class.eventq-notice--info]="tone() === 'info'"
  [attr.data-tone]="tone()"
  role="status"
>
  <span class="eventq-notice__icon" aria-hidden="true">
    <img [src]="resolvedIconSrc()" alt="" width="24" height="24" />
  </span>
  <div class="eventq-notice__message">{{ message() }}</div>
</section>
